import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import "./VersionHistoryModal.scss";
import Modal from "../__common/Modal/Modal";
import { CBType, Checkbox } from "../__common/_controls/Checkbox/Checkbox";
import { VersionHistoryState } from "../../types/version-history";
import classNames from "classnames";
import { UtilsKeyboardAccessibility } from "../../utils/UtilsKeyboardAccessibility";

interface Props {
  show?: boolean;
  selectedHistory: VersionHistoryState | undefined;
  onHide?: () => void;
  onHistorySelect: (h: VersionHistoryState) => void;
  headertestid?: string;
  versionHistories: VersionHistoryState[] | undefined;
}

export const VersionHistoryModal: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const {
    show = false,
    selectedHistory,
    onHide,
    onHistorySelect,
    headertestid,
    versionHistories,
  } = props;

  const handleOnHide = () => {
    if (onHide) {
      onHide();
    }
  };

  useEffect(() => {
    if (show) {
      UtilsKeyboardAccessibility.setFocus("version-history-modal");
    }
  }, [show]);

  useEffect(() => {
    UtilsKeyboardAccessibility.addTabEventListener(
      "last-version",
      "version-history-modal"
    );

    return () => {
      UtilsKeyboardAccessibility.removeTabEventListener(
        "last-version",
        "version-history-modal"
      );
    };
  }, []);

  return (
    <Modal
      testId="version-history-modal"
      show={show}
      wrapperClassName="version-history-modal"
      id="version-history-modal"
    >
      <Modal.Header headertestid={headertestid} onHide={handleOnHide}>
        <Modal.Title>
          {t("PRIVACY_POLICY_GPP_VERSION_HISTORY_POPUP_TITLE")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body isNoFooter>
        {versionHistories &&
          versionHistories.map((history, index, { length }) => {
            const wrapClass = classNames("version-history-modal__item", {
              active: selectedHistory?.name === history.name,
            });
            const isLast = length - 1 === index;

            return (
              <div
                className={wrapClass}
                key={history.name}
                id={isLast ? "last-version" : undefined}
              >
                <Checkbox
                  testId="onhistory-select-button"
                  title={history.displayDate}
                  name="checkbox-withoutSelectBg"
                  type={CBType.withoutSelectBg}
                  className="language-modal__checkbox"
                  checked={selectedHistory?.displayDate === history.displayDate}
                  onClick={() => onHistorySelect(history)}
                  onKeyPress={() => onHistorySelect(history)}
                />
              </div>
            );
          })}
      </Modal.Body>
    </Modal>
  );
};
